// Lib
import { mapInlineStyleToMark } from '@tiptap/draftjs-to-tiptap';
import { convertInlineStyleToTiptapMark } from '../../../utils/tiptapInlineStyleUtils';

// Types
import { MapStyleToMarkFn } from './draftToTiptapConverterTypes';

/**
 * Converts Draft.js inline style to Tiptap marks.
 * Adds custom Milanote-specific handling for text and background color, otherwise
 * delegates to the default draftjs-to-tiptap implementation.
 */
export const convertDraftInlineStyleToTiptapMark: MapStyleToMarkFn = (context) => {
    const { range } = context;

    const inlineStyleMark = convertInlineStyleToTiptapMark(range.style);
    if (inlineStyleMark) return inlineStyleMark;

    return mapInlineStyleToMark(context);
};

export default convertDraftInlineStyleToTiptapMark;
